import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { ModuleWithProviders, NgModule, Provider, Type } from '@angular/core';

import { LanguageModule } from '@language';
import { ShAbstractHttpService } from '@stylehaven/components';
import { ArrowNavigationDirective } from './directives/arrow-navigation.directive';
import { MiddlewareService } from './services/middleware/middleware.abstract.service';

@NgModule({
    imports: [CommonModule, HttpClientModule, LanguageModule],
    declarations: [ArrowNavigationDirective],
    exports: [ArrowNavigationDirective]
})
export class SharedModule {
    static forRoot(
        httpService: Type<ShAbstractHttpService>,
        middleware?: Type<MiddlewareService>
    ): ModuleWithProviders<SharedModule> {
        const providers: Provider[] = [{ provide: ShAbstractHttpService, useClass: httpService }];

        if (middleware) {
            providers.push({ provide: MiddlewareService, useClass: middleware });
        }
        return {
            ngModule: SharedModule,
            providers
        };
    }
}
